import { create } from 'zustand';

export interface ABTestData {
  categoryOrdering?: 'popular' | 'popular_view_count';
  recommendationOrderType?: 'booked';
  storyRecommendationSimsType?: 'personalize' | 'inference';
  chatbotGroupKey?: string;
  llmPresetCode?: string | undefined;
  groupKey?: string | undefined;
  prvGroupKey?: string | undefined;
  episodeChatGroupKey?: string | undefined;
  messageSummary?: string | undefined;
}

interface ABTestStore extends ABTestData {
  isDataReceived: boolean;
  setABTestData: (abTestData: ABTestData) => void;
  setIsDataReceived: (isReceived: boolean) => void;
}

export const useABTestStore = create<ABTestStore>((set) => ({
  categoryOrdering: undefined,
  recommendationOrderType: undefined,
  isDataReceived: false,
  storyRecommendationSimsType: undefined,
  chatbotGroupKey: undefined,
  llmPresetCode: undefined,
  groupKey: undefined,
  prvGroupKey: undefined,
  episodeChatGroupKey: undefined,
  messageSummary: undefined,

  setABTestData(abTestData) {
    set({ ...abTestData, isDataReceived: true });
  },
  setIsDataReceived(isReceived) {
    set({ isDataReceived: isReceived });
  },
}));
